"use client";
import { useStatsigClient, useExperimentLogger } from "@repo/statsig";

/**
 * Synchronous hook to get the value of a Statsig experiment.
 * Returns the value directly without loading state tracking.
 *
 * Use useExperimentValue instead when you need loading state awareness
 * to prevent content flicker during Statsig initialization.
 *
 * @param experimentName - The name of the Statsig experiment.
 * @param key - The key to get from the experiment.
 * @param fallback - The fallback value if the experiment or key is not found.
 * @returns The experiment value as a string.
 * @deprecated Use useExperimentValue instead for better loading state handling
 */
export function useExperimentValueSync(
  experimentName: string,
  key: string,
  fallback: string
): string {
  const { client } = useStatsigClient();

  const experiment = client.getExperiment(experimentName);
  const experimentValue = experiment.get(key, fallback);

  useExperimentLogger(experimentName, key, experimentValue, experiment.details);

  return experimentValue;
}
